import {FC, useEffect, useState} from 'react'
import {useSelector} from 'react-redux'

import {useLazyAdminGetUserCommissionAmountQuery} from '../../../../../services/cellcast.v2'
import {Spinner} from 'react-bootstrap'
import ReactDatePicker from 'react-datepicker'
import moment from 'moment-timezone'
import { useLocation } from 'react-router-dom'

const ReferralCommissionAmount: FC = () => {
  const location = useLocation()
  const {userProp} = location.state || ({} as any)
  
  const userDataState = useSelector((state: any) => state?.ProfileData?.ProfileData?.user || {})
  const userData = userProp?.user ? userProp.user : userDataState

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null])
  const [startDate, endDate] = dateRange

  const [triggerFetch, setTriggerFetch] = useState(false)

  const setDateParams = (dateRangeParams: [Date | null, Date | null]) => {
    let [startDate, endDate] = dateRangeParams
    if (endDate === null) {
      endDate = new Date()
    }

    setDateRange(dateRangeParams)
    setTriggerFetch(true)
  }

  const [
    getCreditCommission,
    {
      data: creditCommission,
      isLoading: creditCommissionLoading,
      isFetching: creditCommissionFetching,
    },
  ] = useLazyAdminGetUserCommissionAmountQuery()
  const [
    getMoneyCommission,
    {data: moneyCommission, isLoading: moneyCommissionLoading, isFetching: moneyCommissionFetching},
  ] = useLazyAdminGetUserCommissionAmountQuery()

  useEffect(() => {
    if (userData && userData._id) {
      getCreditCommission({commissionType: 'credit', userId: userData._id})
      getMoneyCommission({commissionType: 'money', userId: userData._id})
    }
  }, [userData])

  useEffect(() => {
    if (triggerFetch === true) {
      const [startFilterDate, endFilterDate] = dateRange
      getCreditCommission({
        userId: userData._id,
        commissionType: 'credit',
        fromDate: startFilterDate ? moment(startFilterDate).format('YYYY-MM-DD') : undefined,
        toDate: endFilterDate ? moment(endFilterDate).format('YYYY-MM-DD') : undefined,
      })
      getMoneyCommission({
        userId: userData._id,
        commissionType: 'money',
        fromDate: startFilterDate ? moment(startFilterDate).format('YYYY-MM-DD') : undefined,
        toDate: endFilterDate ? moment(endFilterDate).format('YYYY-MM-DD') : undefined,
      })
      setTriggerFetch(false)
    }
  }, [triggerFetch])

  return (
    <>
      <div className='card mb-6'>
        <div className='card-body'>
          <div className='d-flex flex-wrap flex-sm-nowrap'>
            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column'>
                  <div className='d-flex align-items-center mb-2'>
                    <span className='text-gray-900 text-hover-primary fs-2 fw-bolder me-1'>
                      Commission Amount
                    </span>
                  </div>
                </div>
                <div className='d-flex justify-content-end'>
                  <div className='col-md-12'>
                    <div className='d-flex'>
                      <ReactDatePicker
                        selectsRange={true}
                        dateFormat='MMM d, yyyy'
                        className=' border-0 form-control form-control-lg form-control-solid'
                        placeholderText='Pick date & time'
                        onChange={setDateParams}
                        startDate={startDate}
                        endDate={endDate}
                      />
                      <span
                        className='input-group-text'
                        style={{
                          backgroundColor: '#f5f8fa',
                          borderRadius: 0,
                          borderColor: '#f5f8fa',
                        }}
                      >
                        <i className='bi bi-calendar'></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex flex-wrap flex-sm-nowrap'>
            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column col-lg-12'>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <div className='row'>
                        <div
                          className='col-lg-12 d-flex justify-content-center align-items-center'
                          style={{minHeight: 100}}
                        >
                          {creditCommissionLoading || creditCommissionFetching ? (
                            <Spinner />
                          ) : (
                            <h1 className='fw-bolder m-0' style={{fontSize: 40}}>
                              {creditCommission && creditCommission.data
                                ? creditCommission?.data.totalAmount.toFixed(2)
                                : 0}
                            </h1>
                          )}
                        </div>
                        <div className='col-lg-12 text-center mb-5'>
                          <h4 className='fw-bolder m-0 fs-6'>Total Credit Commission</h4>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-6'>
                      <div className='row'>
                        <div
                          className='col-lg-12 d-flex justify-content-center align-items-center'
                          style={{minHeight: 100}}
                        >
                          {moneyCommissionLoading || moneyCommissionFetching ? (
                            <Spinner />
                          ) : (
                            <h1 className='fw-bolder m-0' style={{fontSize: 40}}>
                              $
                              {moneyCommission && moneyCommission.data
                                ? moneyCommission?.data.totalAmount.toFixed(2)
                                : 0}
                            </h1>
                          )}
                        </div>
                        <div className='col-lg-12 text-center mb-5'>
                          <h4 className='fw-bolder m-0 fs-6'>Total Money Commission</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ReferralCommissionAmount
